import { HashLink } from 'react-router-hash-link';

import useHeadingsData from './hooks/useHeadingsData';
import useLocalizedFormattedText from '@frolight/hooks/useLocalizedFormattedText';

const TableOfContents = ({ children }) => {
  const { lftext } = useLocalizedFormattedText();

  const { headings } = useHeadingsData(children);

  return (
    <>
      <nav
        aria-label="Table of contents"
        className="table_of_contents"
      >
        <h2 className="table_of_contents__title">
          { lftext('components.table_of_contents.title') }
        </h2>
        <ul className="table_of_contents__list">
          {
            headings.map(heading => (
              <li
                key={ heading.id }
                className={ `table_of_contents__entry  table_of_contents__entry--level_${heading.level}` }
              >
                <HashLink
                  smooth
                  to={ `#${heading.id}` }
                >
                  { heading.text }
                </HashLink>
              </li>
            ))
          }
        </ul>
      </nav>
      { children }
    </>
  )
}

export default TableOfContents;